import clsx from 'clsx';
import React from 'react';

interface PictureCaptionProps {
  className?: string;
  pictureCaption: string;
}

export const PICTURE_CAPTION_CLASSES =
  'mt-8 self-end text-right font-suisse-intl-mono text-overline-sm text-grayscale-gray sm:text-caption-sm lg:w-[260px] lg:flex-shrink-0 lg:self-auto';

const PictureCaption = ({ className, pictureCaption = '' }: PictureCaptionProps) => {
  return (
    <span id="caption-text" className={clsx(PICTURE_CAPTION_CLASSES, className)}>
      {pictureCaption}
    </span>
  );
};

export default PictureCaption;
